import { use } from 'react';
import { JsonLd } from '@/components/json-ld';

export function ContentJsonLd({ promise }: { promise: Promise<Record<string, unknown> | null> }) {
    const data = use(promise);
    return data ? <JsonLd id="content-schema" data={data} /> : null;
}
